import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as analyseActions from '../../actions/analytics';
import C_A from '../../constants/analytics';
import C from '../../constants/app';
import { getModuleFromPath, getPageFromPath } from '../../utils/getModuleFromPath';
import { setGlobalContextProperty, trackPageView } from '../../utils/mixpanelUtils';
import { isMixpanelReady } from '../../utils/setupMixpanel';


const LogPageView = (WrappedComponent) => {
    class Logger extends React.Component {
        componentWillMount() {
            let page;
            if (this.props.location.pathname.indexOf(this.props.match.params.id) > -1) {
                page = this.props.location.pathname.slice(0, this.props.location.pathname.indexOf(this.props.match.params.id));
            }
            else {
                page = this.props.location.pathname;
            }
            this.props.actions.reportAnalytics([C_A.PAGE_VIEW, page]);

            if (this.props.canSendAnalytics && isMixpanelReady()) {
                setGlobalContextProperty('module', getModuleFromPath(this.props.location.pathname));
                trackPageView(getPageFromPath(this.props.location.pathname));
            }
        }

        render() {
            return <WrappedComponent {...this.props} />
        }
    }

    Logger.propTypes = {
        match: PropTypes.object,
        location: PropTypes.object.isRequired,
        actions: PropTypes.object.isRequired,
        canSendAnalytics: PropTypes.bool
    };

    function mapStateToProps(state) {
        return {
            canSendAnalytics: state.app.getIn([C.SSP_PERMISSIONS_LIST]).canSendAnalytics
        };
    }

    function mapDispatchToProps(dispatch) {
        return {
            actions: bindActionCreators(analyseActions, dispatch)
        }
    }

    return connect(mapStateToProps, mapDispatchToProps)(Logger);
}

export default LogPageView;




// WEBPACK FOOTER //
// ./containers/AnalyticsWrapper/index.js